import { motion } from "framer-motion";
import { CheckCircle2, Send, RotateCcw } from "lucide-react";

const ROWS = [
  { icon: Send, label: "Transmises", value: "12 480 €", dot: "#176b70" },
  { icon: CheckCircle2, label: "Acceptées", value: "11 920 €", dot: "#2e7d32" },
  { icon: RotateCcw, label: "À corriger", value: "320 €", dot: "#e65100" },
];

const HeroVisual = () => (
  <div className="relative hidden lg:block" data-testid="hero-visual">
    <div className="absolute -top-14 -right-8 h-60 w-60 dotted-bg rounded-full opacity-70" aria-hidden="true" />
    <div className="absolute -bottom-8 right-16 h-3.5 w-3.5 rounded-full bg-[#b5c4b1]" aria-hidden="true" />

    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
      className="relative"
    >
      <motion.div
        animate={{ y: [0, -8, 0] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
        className="relative rounded-3xl border border-[#e5e1d8] bg-white shadow-[0_40px_90px_-35px_rgba(13,39,49,0.45)] overflow-hidden"
      >
        <div className="flex items-center justify-between px-7 py-5 border-b border-[#e5e1d8]">
          <p className="text-sm font-extrabold tracking-tight text-[#0d2731]">Suivi de facturation</p>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-[#f6f3ec] border border-[#e5e1d8] px-3 py-1.5 text-[11px] font-bold text-[#176b70]">
            <span className="dot-sage" />
            À jour
          </span>
        </div>

        <ul className="px-7 py-6 space-y-5">
          {ROWS.map((r, i) => (
            <motion.li
              key={r.label}
              initial={{ opacity: 0, x: 18 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.85 + i * 0.15, duration: 0.55, ease: "easeOut" }}
              className="flex items-center gap-3.5"
            >
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[#f6f3ec] border border-[#e5e1d8] text-[#176b70]">
                <r.icon className="h-4 w-4" strokeWidth={1.9} />
              </span>
              <span className="flex-1 text-sm font-semibold text-[#0d2731]">{r.label}</span>
              <span className="text-sm font-extrabold text-[#0d2731] tabular-nums">{r.value}</span>
              <span className="h-2 w-2 rounded-full" style={{ backgroundColor: r.dot }} aria-hidden="true" />
            </motion.li>
          ))}
        </ul>

        <div className="px-7 pb-7">
          <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-[#f6f3ec]">
            <motion.div className="h-full bg-[#2e7d32]" initial={{ width: 0 }} animate={{ width: "95.5%" }} transition={{ delay: 1.4, duration: 1, ease: [0.22, 1, 0.36, 1] }} />
            <motion.div className="h-full bg-[#e65100]" initial={{ width: 0 }} animate={{ width: "2.6%" }} transition={{ delay: 1.55, duration: 0.8, ease: [0.22, 1, 0.36, 1] }} />
          </div>
        </div>
      </motion.div>
    </motion.div>
  </div>
);

export default HeroVisual;
